var map = {
	"./music-instructions.json": 5149,
	"./music-library-intro2024.json": 5150,
	"./music-library-launch2024.json": 5151,
	"./music-progression.json": 5152,
	"./startSourcesAdvanced.json": 5153,
	"./startSourcesSimple.json": 5154,
	"./startSourcesSimple2.json": 5155,
	"./startSourcesTracks.json": 5156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4847;